var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppModal", {
    attrs: {
      id: "delete-store-modal",
      action: "Delete Funnel",
      title: "Are you sure?",
      subheading:
        "Just confirming that you want to delete this funnel. This action cannot be undone.",
      "secondary-action": "Cancel",
      actionColor: "danger",
      secondaryActionColor: "black",
      hideClose: ""
    },
    on: {
      close: _vm.closeModal,
      "secondary-cta": _vm.closeModal,
      cta: _vm.deleteFunnel
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }